export const baseUrl = () => process.env.internalBaseUrl.replace(/\/$/, ''); // 'https://bravado.co';

export const makeUrl = (url, encoded = false) => {
  const fullUrl = `${baseUrl()}${url}`;
  return (encoded && encodeURIComponent(fullUrl)) || fullUrl;
};

export const open = (url, ...rest) => window.open(url, ...rest);

export const redirectTo = url => {
  window.location.href = url;
};

export const buildQuery = (params, filterEmpty = false) => {
  if (!params) return '';

  const query = Object.entries(params).reduce((acc, [key, val]) => {
    if (!val && filterEmpty) return acc;

    acc.push(`${key}=${val}`);
    return acc;
  }, []);

  return query.length ? `?${query.join('&')}` : '';
};

export const isUrl = string => {
  try {
    // eslint-disable-next-line no-new
    new URL(string);
  } catch {
    return false;
  }

  return true;
};

export const createStripeDashboardURL = path => {
  const redirectUrl = makeUrl(path);
  return `https://connect.stripe.com/express/oauth/authorize?redirect_uri=${redirectUrl}&client_id=${process.env.STRIPE_CLIENT_ID}`;
};

/**
 * Extract utms from query
 * @param {*} this.$route.query
 * @returns
 */
export const getUtmParams = routerQuery => {
  return Object.entries(routerQuery).reduce((utms, [name, value]) => {
    if (name.toLowerCase().startsWith('utm_')) {
      utms[name] = value;
    }
    return utms;
  }, {});
};
